import $ from 'jquery'
import { goalbookUrls } from '@/links'
import { defaultMemoryCache, ajaxCacheWrapper } from './cache'

export {
  getStandards,
  getValidStandardSets,
  getItem,
  getResource,
  getStandardsQuery,
  getResources,
  getCuratedCollection,
  getAllCuratedCollections,
  getRelevantGoalsForText,
  getSdiStudentCharacteristics,
  getSdiStategies,
  getAlgoliaAPIKey
}

function getStandards(standardRefs, queryParams = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/standards`,
    method: 'GET',
    dataType: 'json',
    data: $.param({ ...queryParams, standards: standardRefs.join(',') }),
    xhrFields: { withCredentials: true }
  })
}

function getValidStandardSets() {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/standards/sets`,
    method: 'GET',
    dataType: 'json'
  })
}

function getItem(itemId, queryParams = { denormalized: 1 }) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/items/${itemId}`,
    method: 'GET',
    dataType: 'json',
    data: $.param(queryParams),
    xhrFields: { withCredentials: true }
  })
}

function getResource(resourceId, queryParams = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/resources/${resourceId}`,
    method: 'GET',
    dataType: 'json',
    data: $.param(queryParams),
    xhrFields: { withCredentials: true }
  })
}

function getResources(resourceIds, queryParams = {}) {
  if (!resourceIds || resourceIds.length === 0) {
    return Promise.resolve([])
  }
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/resources`,
    method: 'GET',
    dataType: 'json',
    data: $.param(Object.assign({ uuids: resourceIds }, queryParams)),
    xhrFields: { withCredentials: true }
  })
}

function getStandardsQuery(setCode, params = {}) {
  var url = `${goalbookUrls.pathwaysApi}/standards/${setCode}/query`
  if (params.select_fields) {
    params.select_fields = params.select_fields.join(',')
  }
  if (params.standards) {
    // I join the arrays into a string before calling param because otherwise the url gets too long
    params.standards = params.standards.join(',')
  }
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: url,
    method: 'POST',
    data: $.param(params)
  })
}

function getCuratedCollection(id) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/collections/curated/${id}`,
    method: 'GET',
    dataType: 'json',
    xhrFields: {withCredentials: true}
  })
}

async function getAllCuratedCollections(queryParams = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/collections/curated`,
    method: 'GET',
    data: $.param(queryParams),
    dataType: 'json',
    xhrFields: {withCredentials: true}
  })
}

async function getRelevantGoalsForText(body) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/relevant_goals`,
    method: 'POST',
    dataType: 'json',
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(body),
    xhrFields: { withCredentials: true }
  })
}

async function getSdiStudentCharacteristics(body) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/sdi_generation/student_characteristics`,
    method: 'GET',
    dataType: 'json',
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(body),
    xhrFields: { withCredentials: true }
  })
}

async function getSdiStategies(body) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${goalbookUrls.pathwaysApi}/sdi_generation/goal_strategies`,
    method: 'POST',
    dataType: 'json',
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(body),
    xhrFields: { withCredentials: true }
  })
}

async function getAlgoliaAPIKey(featureName, indices) {
  let url = `${goalbookUrls.pathwaysApi}/algolia_api_key`

  const params = new URLSearchParams({ indices, feature_name: featureName })

  url += `?${params.toString()}`

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
  })
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw new Error(`Failed request for new Algolia API key. Status: ${response.status}. Response: ${JSON.stringify(responseJSON)}`)
}
